var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_setup.classes({ theme: _setup.variant.theme }),attrs:{"data-uh":"property-type-pill","data-theme":_setup.variant.theme}},[_c(_setup.PropertyTypeIcon,{attrs:{"type":_setup.variant.iconType}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_setup.variant.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }